export interface CompletedWorkAccessModel {
  // General access section.
  canReadCompletedWorkAsAdmin: boolean;
  canReadCompletedWork: boolean;
}


export const COMPLETED_WORK_ACCESS_DEFAULT: CompletedWorkAccessModel = {
  canReadCompletedWorkAsAdmin: false,
  canReadCompletedWork: false
};
